export class User {
  id = 0;
  magic_key: string;
  wmk: string;
  sex: string;
  birthtime: number;
  profile_age: number;
  shipping_name: string;
  shipping_surname: string;
  shipping_phone: string;
  ack_tcs: string;
  ack_privacy: string;
  lang: string;
  picture_src_icon: string;
  picture_src_ava: string;
  picture_src_preview: string;
  native_group: object;
  payload: string;
  points: number;
  rank: number;

  cup_position: number;
  cup_status: string;
  call_game_status: boolean;
  call_game_description: string;
  games: object[];

  bonus_points: number;
  measure_type: string;
  created_time:number;
  classes:object[];
  friends:object[];
  referrals:object[];
  sig:string;

  customisable_settings: object = {};
  change_password = false;
  _auth_code: string;

  public static checkProfilesForGame(profile1:User,profile2:User) {
    let available = false;
    profile1.classes.forEach( class1 => {
      if(class1['profiles'].find(profileInClass => { return profileInClass['id'] == profile1.id && profileInClass['membership'] == 'active' }) &&
         class1['profiles'].find(profileInClass => { return profileInClass['id'] == profile2.id && profileInClass['membership'] == 'active' })) {
        console.log('checkProfilesForGame available by class',class1);
        available = true;
      }
    })
    if(available) return available;

    profile1.friends.forEach( friend1 => {
      if(friend1['id'] == profile2['id'] && friend1['relation_params']['status'] == 'active') {
        console.log('checkProfilesForGame available by friend',friend1);
        available = true;
      }
    })
    return available;
  }

  public static findProfileClassRelation(profile1:User,classID:number): string {
    const profileClass = profile1.classes.filter( profileClass => { return profileClass['id'] == classID } )[0]
    const classProfile = profileClass ? profileClass['profiles'].filter(classProfile => { return classProfile['id'] == profile1.id})[0] : null;
    return classProfile ? classProfile['membership'] : '';
  }

  public static checkIfFriend(profile1:User,user2ID:number): boolean {
    if(profile1.id == user2ID) return false;
    if(!profile1.friends || !profile1.friends.length) return false;
    return profile1.friends.find(friend => (friend['id'] == user2ID && friend['relation_params']['status'] == 'active')) ? true : false
  }

  public static getRelationStatus(profile1:User,user2ID:number): string {
    if(profile1.id == user2ID) return '';
    if(profile1.friends?.length) {
      let friendFound = profile1.friends.find(friend => (friend['id'] == user2ID));
      if(friendFound) return friendFound['relation_params']['status'];
    }
    if(profile1.referrals?.length) {
      let referralFound = profile1.referrals.find(referral => (referral['id'] == user2ID));
      if(referralFound) return referralFound['relation_params']['status'];
    }
    return '';
  }
  public static getRelationAction(profile1:User,user2ID:number): string {
    if(profile1.id == user2ID) return '';
    if(profile1.friends?.length) {
      let friendFound = profile1.friends.find(friend => (friend['id'] == user2ID));
      if(friendFound) return friendFound['relation_params']['action'];
    }
    if(profile1.referrals?.length) {
      let referralFound = profile1.referrals.find(referral => (referral['id'] == user2ID));
      if(referralFound) return referralFound['relation_params']['action'];
    }
    return '';
  }

  public static isTrainer(profile:User): boolean {
    // return false;
    return (profile && profile['native_group'] && ['trainer','owner'].includes(profile['native_group']['status']));
  }

  public static isOwner(profile:User): boolean {
    // return false;
    return (profile && profile['native_group'] && ['owner'].includes(profile['native_group']['status']));
  }
}
